<!-- Alert when offline. -->
<div class="offline-alert" *ngIf="!isConnected"></div>

<!-- Page header. -->
<header
	*ngIf="showHeader && isUserLogged"
	[isUserVisible]="userIsVisible"
	(onChangeStatus)="changeUserVisibility($event)"
></header>
<!-- Notifications. -->
<app-notifications *ngIf="allowNotifications"></app-notifications>

<!--zen-chat -->
<zen-chat></zen-chat>
<router-outlet
	(toggleNotificationsVisibility)="toggleNotificationsVisibility($event)"
	(window:resize)="onResize()"
></router-outlet>
<!-- Dynamic content. -->
<promptuary-sidebar *ngIf="isUserLogged"></promptuary-sidebar>

<freud-toast position="top-right"> </freud-toast>
